import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <p>{I18n.t("papp.products.EditProductView.StepAvailability.hint.p1")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepAvailability.hint.p2")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepAvailability.hint.p3")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepAvailability.hint.p4")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepAvailability.hint.p5")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepAvailability/StepAvailabilityHint.jsx